import { createWorker } from "tesseract.js";

import { pdfDownloadUrlToMarkdown } from './pdfToMarkdown.js';
import { wordDownloadUrlToMarkdown } from './wordToMarkdown.js';
import { getDownloadUrl } from "./getDownloadUrl.js";

export const fileToMarkdown = async (file, options = {}) => {
	let markdown = '';
	const url = await getDownloadUrl(file.path);
	if (file.type.includes('image/')) {
		const worker = await createWorker("eng");
		const result = await worker.recognize(url);
		markdown += result?.data?.text || 'No text returned for this image';
	}
	if (file.type === 'application/pdf') {
		const { text, pageImages } = await pdfDownloadUrlToMarkdown(url, options);
		if (text) {
			markdown = text;
		} else {
			console.warn('No markdown text returned');
			console.log({ pageImages });
			const worker = await createWorker("eng");
			for (const imageUrl of pageImages) {
				const result = await worker.recognize(imageUrl);
				console.log({ result });
				if (markdown) markdown += '\n\n';
				markdown += result?.data?.text || 'No text returned for this page';
			}
			await worker.terminate();
		}
	}
	if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
		markdown = await wordDownloadUrlToMarkdown(url, options);
	}
	return `${file.name}\n\n${markdown.trim()}`;
};
